export default __webpack_public_path__ + "static/media/Tick.201f8c6e.svg";